<!-- 个人信息 -->
<template>
	<div class="personal-info">
		<div class="item">
			<span>头像</span>
			<img :src="userInfo.avatar" alt="">
		</div>
		<div class="item">
			<span>昵称</span>
			<p>{{userInfo.nickname}}</p>
		</div>
		<div class="item">
			<span>账号</span>
			<p>{{userInfo.mobile}}</p>
		</div>
		<!-- <div class="exitBtn" @click="logoutLogin">
			退出登录
		</div> -->
	</div>
</template>
<script>
	import {PersoanalLogout} from '../../config/interface.js'
	export default{
		data(){
			return{
				userInfo:this.$store.state.userInfo
			}
		},
		mounted(){
			// console.log(111)
		},
		methods:{
			//退出登录
			logoutLogin(){
				const url=PersoanalLogout;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.$router.go(-1);
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.personal-info{
		padding:0 12px;
		.item{
			border-bottom:1px solid #ccc;
			padding:14px 0;
			@include flex(row);
			justify-content:space-between;
			align-items:center;
			span{
				color:#353535;
				font-size:13px
			}
			p{
				font-size:13px;
				color:#929292;
			}
			img{
				width:40px;
				height:40px;
				border-radius:50%;
			}
		}
		.exitBtn{
			position: absolute;
			width:100%;
			bottom: 0px;
			left:0px;
			height:44px;
			line-height:44px;
			text-align: center;
			color:#fff;
			font-size:15px;
			letter-spacing:1px;
			background: $color-main;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/personal/PersonalInfo.vue